module.exports = __webpack_public_path__ + "img/294.04788631.svg";